import React from 'react';

const AdvancedRules = () => {
  const action = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/action.png'}
    alt={'Действие'}
    title={'Действие в Фазе Строительства'}
  />;
  const road = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/road.1f281346.png'}
    alt={'Дорога'}
    title={'Дорога'}
  />;
  const centralQuarter = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/icons/central quarter.7dd51bfd.png'}
    alt={'Центральный квартал'}
    title={'Центральный квартал'}
  />;
  const quarter = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/quarter.f69660fa.png'}
    alt={'Базовый квартал'}
    title={'Базовый квартал'}
  />;
  const specialBuildings = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/special buildings/special building.c496c562.png'}
    alt={'Специальное строение'}
    title={'Специальное строение'}
  />;
  const buildingDamage = <img
    className={'policy-description-icon'}
    src={'/img/icons/building_damage.png'}
    alt={'Повреждение'}
    title={'Повреждение строения'}
  />;
  const fortress = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/special buildings/fortress button.6fed26ae.png'}
    alt={'Крепость'}
    title={'Крепость'}
  />;
  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d4 friend.png'}
    alt={'Катапульта'}
    title={'Катапульта'}
  />;
  const distance = <img
    className={'policy-description-icon'}
    src={'/img/icons/distance.png'}
    alt={'Дальность'}
    title={'Дальность'}
  />;
  const mountain = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/mountains/mountain_rock_1.862dc5c3.png'}
    alt={'Гора'}
    title={'Гора'}
  />;
  const dice = <img
    className={'policy-description-icon'}
    src={'/img/icons/cube.png'}
    alt={'Кость урона'}
    title={'Кость урона'}
  />;
  const damage = <img
    className={'policy-description-icon'}
    src={'/img/icons/damage.png'}
    alt={'Урон'}
    title={'Урон'}
  />;
  const barracks = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/barracks.efab12f7.png'}
    alt={'Казарма'}
    title={'Казарма'}
  />;
  const size = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/unit size.png'}
    alt={'Размер'}
    title={'Размер отряда'}
  />;

  return (
    <div className="rules-page_content">
      <h2 className="rules-page_title text-attention">
        Правила для опытных игроков
      </h2>

      <div className="rules-page_section">
        <h2>Повреждение и разрушение строений</h2>
        <p>
          Если строение по каким-либо правилам повреждается {buildingDamage}, то на нем на поле размещается жетон
          повреждения. Все строения, кроме крепости {fortress}, которые получают 2-ой жетон повреждения,
          разрушаются:
        </p>
        <ul>
          <li>Обычное строение — жетон переворачивается на сторону дороги {road}.</li>
          <li>Специальное строение {specialBuildings} — убирается с поля.</li>
        </ul>
        <p>
          Все строения с жетоном повреждения, кроме крепости {fortress}, не работают, пока не будут отремонтированы
          (пока не будут убраны все их жетоны повреждений). В фазе Строительства игрок может осуществить ремонт
          строения (сбросить 1 жетон повреждения) за 1 действие {action}.
        </p>
        <p>
          Повредить базовый квартал {quarter} можно только после разрушения стоящего на нем специального строения,
          если такое есть. Уничтожить центральный квартал {centralQuarter} (положить 2-ой жетон повреждения) можно
          только после разрушения всех смежных базовых кварталов {quarter}.
        </p>
      </div>

      <div className="rules-page_section">
        <h2>Крепость {fortress}</h2>
        <ul>
          <li>Можно размещать на любой непустой ячейке, на которой нет других специальных строений — в том числе на
            центральном квартале {centralQuarter} города. Но не на дороге {road}.
          </li>
          <li>Строится не мгновенно, а только в следующем раунде в фазе Строительства игрока: изначально игрок
            размещает на выбранной ячейке жетон крепости обратной стороной вверх. В свою следующую фазу Строительства
            игрок бесплатно переворачивает этот жетон на активную сторону — это не тратит действие {action} игрока.
          </li>
          <li>Строительство не может быть завершено, если крепость находится в зоне контроля отряда противника.</li>
          <li>Разрушается после 10 повреждений {buildingDamage}.</li>
          <li>В ближнем бою против отряда в крепости урон {damage} всегда наносится так: из каждых 3 урона отряда
            противника 2 урона поглощает крепость, а 1 урон получает отряд игрока в крепости. За каждые 2 поглощенных
            урона крепость получает 1 жетон повреждения {buildingDamage}. Остаток от деления урона на 3 не наносит
            урона ни крепости, ни отряду.
          </li>
          <li>Если прочность крепости падает до 0, она разрушается. Если противник наносит урона
            больше, чем крепость может поглотить, весь оставшийся урон наносится отряду, который располагался в
            крепости.
          </li>
        </ul>
      </div>

      <div className="rules-page_section">
        <h2>Катапульты {unit}</h2>
        <p>
          Размер {size} снабженной Катапульты растет только на 1 и только на казарме {barracks} — вне казармы снабженный
          отряд не меняет свой размер, если получает снабжение.
          <br/>Катапульты теряют размер по стандартным правилам, если не получают снабжение (по 2 размера в конце фазы Снабжения).
        </p>

        <h3>Ограничения стрельбы</h3>
        <ul>
          <li>Может стрелять на дальность {distance} до 5 ячеек (то есть между катапультой и целью должно быть не
            более 4 ячеек).
          </li>
          <li>Не может стрелять по ячейке, если на траектории (от центра ячейки с катапультой до центра ячейки-цели)
            или по касательной к ней находится ячейка с горой {mountain} или крепостью {fortress}.
          </li>
          <li>Не может стрелять, если смежно находится отряд противника.</li>
          <li>Может стрелять из крепости {fortress}, если не нарушаются иные правила.</li>
        </ul>

        <h3>Расчет урона стрельбы</h3>
        <p>При стрельбе для Катапульты бросается {dice} 2 кости урона (такие же, что и для ближнего боя):</p>
        <ul>
          <li>Если Катапульта перемещалась в этом раунде — урон = размер Катапульты {size} + <b>худший</b> результат из 2 костей
            урона.
          </li>
          <li>Если Катапульта не перемещалась в этом раунде — урон = размер Катапульты {size} + <b>лучший</b> результат из 2 костей
            урона.
          </li>
        </ul>

        <h3>Урон и повреждение</h3>
        <ul>
          <li>Отряд противника уменьшает свой размер на 1 за каждый 1 урон {damage} стрельбы Катапульты.</li>
          <li>Крепость {fortress} противника получает 1 повреждение {buildingDamage} за каждый 1 урон стрельбы Катапульты.
            Расположенный в крепости отряд противника при этом получает столько же урона.
          </li>
          <li>Если Катапульта стреляет по ячейке, на которой находится строение (не крепость), и наносит 4 и более урона, то
            строение получает жетон повреждения {buildingDamage} (если на ячейке есть специальное строение, оно
            получает повреждение в первую очередь). Отряд противника при этом также теряет размер, равный урону
            стрельбы Катапульты.
          </li>
          <li>Стрельба по своим отрядам и строениям запрещена. Но можно стрелять по ячейке своего города, если в ней
            находится отряд противника — в таком случае свое строение также может получить повреждение.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AdvancedRules;
